import { render, staticRenderFns } from "./ModeratorForm.vue?vue&type=template&id=54e2a9a4&scoped=true&"
import script from "./ModeratorForm.vue?vue&type=script&lang=js&"
export * from "./ModeratorForm.vue?vue&type=script&lang=js&"
import style0 from "./ModeratorForm.vue?vue&type=style&index=0&id=54e2a9a4&scoped=true&lang=css&"
import style1 from "./ModeratorForm.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e2a9a4",
  null
  
)

export default component.exports